export default "__VITE_ASSET__DagUK9VA__"